/**
 * Pricing configuration
 * Single source of truth for subscription price, included credit, and cloud quotas.
 */

/** Paid plans bill this many months up front for a yearly term. */
export const yearlyMonths = 10;

/** Shown on every paid plan card. */
export const paidPlanCard = {
  features: [
    { icon: "check_circle", text: "AI agent credit included", dynamic: true },
    {
      icon: "check_circle",
      text: "Credit expires at end of billing period",
    },
    {
      icon: "check_circle",
      text: "<b>Support the Counterpunch editor development</b>",
    },
  ],
  buttonText: "Subscribe",
  buttonAction: "startSubscription",
  buttonClass: "pricing-button-primary",
};

export function getFreeTrialProduct() {
  return getPricingProducts().freetrial;
}

export function getPricingProducts() {
  return {
    free: {
      id: "free",
      name: "Free",
      pricing: {
        monthly: {
          base: 0,
        },
      },
      pricePeriod: "forever",
      features: [
        { icon: "check_circle", text: "No user account required" },
        { icon: "check_circle", text: "Free font editor usage forever" },
        { icon: "cancel", text: "Can't use AI assistant" },
        { icon: "cancel", text: "No online collaboration" },
      ],
      buttonText: "Just Open Editor ↗︎",
      buttonHref: "https://editor.counterpunch.space",
      buttonClass: "pricing-button-secondary",
      collaboration: false,
    },
    freetrial: {
      id: "freetrial",
      name: "Free Trial",
      pricing: {
        monthly: {
          base: 0,
        },
      },
      creditShare: 0,
      maxFontsOwned: 1,
      maxInvitesPerAsset: 1,
      maxGlyphsPerFont: 1000,
      freeCredits: 0.5,
      creditOverage: false,
    },
    basic: {
      id: "basic",
      name: "Basic",
      stripeProductIds: {
        test: "prod_VK7z6DCmObyzCa",
        live: "prod_VJs9uNCoslU61K",
      },
      pricing: {
        monthly: {
          // Produces €15/month for Germany before tax, adjusted by country.
          base: 17.162399211242686,
        },
      },
      creditShare: 0.5,
      maxFontsOwned: 5,
      maxInvitesPerAsset: 2,
      maxGlyphsPerFont: 2000,
      freeCredits: 0,
      creditOverage: true,
    },
    advanced: {
      id: "advanced",
      name: "Advanced",
      stripeProductIds: {
        test: "prod_VKadtalOjhdZY8",
        live: "prod_VKadKFgakBAiMq",
      },
      pricing: {
        monthly: {
          // Produces €30/month for Germany before tax, adjusted by country.
          base: 34.32479842248537,
        },
      },
      creditShare: 0.4,
      maxFontsOwned: 20,
      maxInvitesPerAsset: 5,
      maxGlyphsPerFont: 10000,
      freeCredits: 0,
      creditOverage: true,
    },
    pro: {
      id: "pro",
      name: "Pro",
      stripeProductIds: {
        test: "prod_VKadCJzhHdYf1o",
        live: "prod_VKadFlt93Nytmi",
      },
      pricing: {
        monthly: {
          // Produces €75/month for Germany before tax, adjusted by country.
          base: 85.81199605621343,
        },
      },
      creditShare: 0.25,
      maxFontsOwned: 50,
      maxInvitesPerAsset: 10,
      maxGlyphsPerFont: 20000,
      freeCredits: 0,
      creditOverage: true,
    },
    enterprise: {
      id: "enterprise",
      name: "Enterprise",
      stripeProductIds: {
        test: "prod_VKadmSA5KLHe2R",
        live: "prod_VKadldlBc3YgHR",
      },
      pricing: {
        monthly: {
          // Produces €150/month for Germany before tax, adjusted by country.
          base: 171.62399211242686,
        },
      },
      creditShare: 0.2,
      maxFontsOwned: 100,
      maxInvitesPerAsset: 20,
      maxGlyphsPerFont: 100000,
      freeCredits: 0,
      creditOverage: true,
    },
  };
}
